import React from 'react';
import PolicyContent from 'components/root/guidance/policy/PolicyContent';

export const PolicyPage: React.FC = () => {
  return <PolicyContent />;
};
